import { Box } from '@chakra-ui/react';
import { ApiKeyTemplateHeader } from './containers/ApiKeyTemplateHeader';
import { ApiKeyTemplateList } from './containers/ApiKeyTemplateList';
import { ApiKeyTemplateRegistrationModal } from './containers/ApiKeyTemplateRegistrationModal';
import { ApiKeyTemplateEditModal } from './containers/ApiKeyTemplateEditModal';
import { ApiKeyTemplateDeleteModal } from './containers/ApiKeyTemplateDeleteModal';

export const ApiKeyTemplatePageView = () => (
  <Box m="40px">
    {/* ヘッダ */}
    <ApiKeyTemplateHeader />
    {/* APIキーテンプレート一覧 */}
    <ApiKeyTemplateList />
    {/* APIキーテンプレート登録モーダル */}
    <ApiKeyTemplateRegistrationModal />
    {/* APIキーテンプレート登録モーダル */}
    <ApiKeyTemplateEditModal />
    {/* APIキーテンプレート削除モーダル */}
    <ApiKeyTemplateDeleteModal />
  </Box>
);
